import { closedAreaContent } from './content'

export function handleError(setError, apiRequest) {
  return async function (...params) {
    try {
      return await apiRequest(...params)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Unable to submit form', error)

      setError('root', {
        type: 'manual',
        message: closedAreaContent.status.error.error,
      })
    }
  }
}
